export type SocieteEnrolmentFilter = 'all' | 'enrolled' | 'not-enrolled';

export interface SocieteEmployeeFilters {
  statuses: Array<App.LuxLoyaltyTier>;
  enrolment: SocieteEnrolmentFilter;
}

export function hasSocieteEmployeeFilters({ statuses, enrolment }: SocieteEmployeeFilters) {
  return statuses.length > 0 || enrolment !== 'all';
}

// null confirms no account; undefined means the current status could not be established.
export function matchesSocieteEmployeeFilters(
  tier: App.LuxLoyaltyTier | null | undefined,
  filters: SocieteEmployeeFilters,
) {
  if (!hasSocieteEmployeeFilters(filters)) return true;
  if (tier === undefined) return false;
  if (filters.statuses.length && (!tier || !filters.statuses.includes(tier))) return false;
  if (filters.enrolment === 'enrolled') return tier !== null;
  if (filters.enrolment === 'not-enrolled') return tier === null;
  return true;
}
